import {configcatClient} from "./client";

// HE_MaintenancePage_20220522
export const checkMaintenancePage = (userId) => {
    return configcatClient.getValueAsync("he_maintenancepage_20220522", false, { identifier: userId });
};

// HE_enableYearEndProcessing_20221130
export const checkYearEndProcessing = () => {
    return configcatClient.getValueAsync("HE_enableYearEndProcessing_20221130", false);
};

// SM_disablePointsValidityExtension_20230209
export const disablePointsValidityExtension = () => {
    return configcatClient.getValueAsync("SM_disablePointsValidityExtension_20230209", true);
};

// HE_disableURLForOnlineAccess_20230502
export const disableURLForOnlineAccess = () => {
    return configcatClient.getValueAsync("HE_disableURLForOnlineAccess_20230502", true);
};

// HE_disableGoogleRecaptchaV2_20230711
export const checkDisableGoogleRecaptchaV2 = () => {
    return configcatClient.getValueAsync("HE_disableGoogleRecaptchaV2_20230711", false);
};

// HE_enableChangingAmountOfGuests_20230728
export const checkChangingAmountOfGuests = (userId, resortId) => {
    return configcatClient.getValueAsync("HE_enableChangingAmountOfGuests_20230728", false, {
        identifier: userId,
        custom: {
            resort_id: String(resortId)
        }
    });
};

// SM_disableRemoveBankAccount_20230810
export const checkDisableRemoveBankAccount = (userId) => {
    return configcatClient.getValueAsync("SM_disableRemoveBankAccount_20230810", false, { identifier: userId });
};

// GN_enableCreditCardForUsMembersWithChfCurrency_20230919
export const checkEnableCreditCardForUsMembersWithChfCurrency = () => {
    return configcatClient.getValueAsync("GN_enableCreditCardForUsMembersWithChfCurrency_20230919", false);
};

// GN_enablePrintAllForBIP_20231120
export const checkEnablePrintAllForBIP = () => {
    return configcatClient.getValueAsync("GN_enablePrintAllForBIP_20231120", false);
};

// GN_enableAnnualSubscriptionInvoice_20231201
export const checkEnableAnnualSubscriptionInvoice = () => {
    return configcatClient.getValueAsync("GN_enableAnnualSubscriptionInvoice_20231201", false);
};

// GN_enableRelatedArticlesInRDP_20231213
export const checkEnableRelatedArticlesInRDP = () => {
    return configcatClient.getValueAsync("GN_enableRelatedArticlesInRDP_20231213", false);
};

// HE_hidePointsFreeCalendar_20231213
export const checkHidePointsFreeCalendar = () => {
    return configcatClient.getValueAsync("HE_hidePointsFreeCalendar_20231213", true);
};

// SM_consentManagementLatestVersionEnabled_20240123
export const checkConsentManagementLatestVersionEnabled = () => {
    return configcatClient.getValueAsync("SM_consentManagementLatestVersionEnabled_20240123", false);
};

// GN_showMarketplaceOnMenuV2_20242008
export const showMarketplaceOnMenuV2 = (userId) => {
    return configcatClient.getValueAsync("GN_showMarketplaceOnMenuV2_20242008", false, { identifier: userId });
};

// HE_showNewsletterSignupV3_20240209
export const checkShowNewsletterSignupV3 = (userId) => {
    return configcatClient.getValueAsync("HE_showNewsletterSignupV3_20240209", false, userId && { identifier: userId });
};

// HE_enableServiceBookingStatusAndCancelService_20230220
export const checkEnableServiceBookingStatusAndCancelService = () => {
    return configcatClient.getValueAsync("HE_enableServiceBookingStatusAndCancelService_20230220", false);
};

// GN_hideVotingBanner_20240226
export const checkHideVotingBanner = (userId) => {
    return configcatClient.getValueAsync("GN_hideVotingBanner_20240226", true, userId && { identifier: userId });
};

// HE_hideCooperationNavigationMenuButton_20240607
export const hideCooperationNavigationMenuBtn = () => {
    return configcatClient.getValueAsync("HE_hideCooperationNavigationMenuButton_20240607", false);
};

// HE_showPartnerAd_20240607
export const checkShowPartnerResortAd = (userId) => {
    return configcatClient.getValueAsync("HE_showPartnerAd_20240607", false, userId && { identifier: userId });
};

// HE_hideMainGuestChange_20240708
export const checkHideMainGuestChange = (userId) => {
    return configcatClient.getValueAsync("HE_hideMainGuestChange_20240708", false, userId && { identifier: userId });
};

// GN_isDirectSalesDisabled_20240809
export const checkDirectSalesDisabled = (userId) => {
    return configcatClient.getValueAsync("GN_isDirectSalesDisabled_20240809", true, userId && { identifier: userId });
};

// GN_isNewPdfContractDisabled_20240913
export const checkNewPdfContractDisabled = (userId) => {
    return configcatClient.getValueAsync("GN_isNewPdfContractDisabled_20240913", true, userId && { identifier: userId });
};

// HE_isNewUiLayoutApartmentCardDisabled_20241003
export const checkNewUiLayoutApartmentCardDisabled = (userId) => {
    return configcatClient.getValueAsync("HE_isNewUiLayoutApartmentCardDisabled_20241003", true, userId && { identifier: userId });
};

// HE_isInviteFriendReferralDisabled_20241114
export const checkInviteFriendReferralDisabled = (userId) => {
    return configcatClient.getValueAsync("HE_isInviteFriendReferralDisabled_20241114", true, userId && { identifier: userId });
};

// HE_isAvailabilityOverviewPageDisabled_20250123
export const checkAvailabilityOverviewPageDisabled = (userId) => {
    return configcatClient.getValueAsync("HE_isAvailabilityOverviewPageDisabled_20250123", true, userId && { identifier: userId });
};

// GN_isOpportunityFlowADisabled_20250203
export const checkOpportunityFlowADisabled = (userId) => {
    return configcatClient.getValueAsync("GN_isOpportunityFlowADisabled_20250203", false, userId && { identifier: userId });
};

// SM_isDatabaseMigrationDisabled_20250213
export const checkDatabaseMigrationDisabled = () => {
    return configcatClient.getValueAsync("SM_isDatabaseMigrationDisabled_20250213", false);
};

// GN_isDocumentsForTrialsAndProspectsDisabled_20250306
export const checkDocumentsForTrialsAndProspectsDisabled = (userId) => {
    return configcatClient.getValueAsync("GN_isDocumentsForTrialsAndProspectsDisabled_20250306", true, userId && { identifier: userId });
};

// GN_isPointsPlatformLatestTermsDisabled_20250425
export const checkPointsPlatformLatestTermsDisabled = () => {
    return configcatClient.getValueAsync("GN_isPointsPlatformLatestTermsDisabled_20250425", true);
};
